import { createBrowserHistory } from 'history';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { ErrorPage } from './auth/pages/ErrorPage';
import { getAuthRouteConfig } from './auth/routeConfig';
import { getRouteConfig as getCommunitiesRouteConfig } from './communities/routeConfig';
import { getRouteConfig as getSystemConfigRouteConfig } from './system-config/routeConfig';

// Get domain-specific route configurations
const authRouteConfig = getAuthRouteConfig();
// Use communities route config
const communitiesRouteConfig = getCommunitiesRouteConfig();
// Use system config route config
const systemConfigRouteConfig = getSystemConfigRouteConfig();

// Create browser history for App Insights integration
export const history = createBrowserHistory();

function getVersionedBasename(): string {
  const path = window.location.pathname.split('/');
  const versionMatch = path[1]?.match(/^v\d+\.\d+\.\d+$/);

  return versionMatch ? `/${versionMatch[0]}` : '';
}

export const router = createBrowserRouter(
  [
    // Include auth routes
    ...authRouteConfig,

    // Include communities routes
    ...communitiesRouteConfig,

    // Include system config routes
    ...systemConfigRouteConfig,

    // Root route redirects to login
    {
      path: '/',
      element: <Navigate replace to="/login" />,
    },

    // Catch-all route for 404 Not Found
    {
      path: '*',
      element: <ErrorPage />,
    },
  ],
  {
    basename: getVersionedBasename(), // Include version in basename if present
    // Note: React Router v7 doesn't directly support history object
    // The history integration will be handled through App Insights React plugin
  }
);
